import { render, staticRenderFns } from "./ListProducts.vue?vue&type=template&id=7fff71de&scoped=true"
import script from "./ListProducts.vue?vue&type=script&lang=ts"
export * from "./ListProducts.vue?vue&type=script&lang=ts"
import style0 from "./ListProducts.vue?vue&type=style&index=0&id=7fff71de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fff71de",
  null
  
)

export default component.exports